var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignAndIllustrationV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.7 98.1",
    style: {
      enableBackground: "new 0 0 290.7 98.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214,10.2c-0.2,2.1-0.4,4.3-0.6,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.6,20.9c1.5-0.2,2.6-1.3,4-1.9s3.4-0.3,3.7,1.1c0.1,0.6,0,1.2-0.3,1.8c-1.1,2.5-3.6,4.4-6.4,4.8 c1.1-0.5,2.3-0.9,3.5-1.1c0.4-0.1,0.9-0.1,1.3,0c0.4,0.1,0.6,0.4,0.9,0.7c1.6,1.9,1.6,5,0,6.9c-1.6,1.9-4.6,2.4-6.8,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,37.8c-0.3,2.6-0.6,5.3-0.9,7.9c0-0.3,0.1-0.7,0.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.4,18.5c-1.7-1-3.7-2.1-5.6-1.4c-1.5,0.5-2.4,1.9-3.2,3.3c-0.4,0.7-0.9,1.5-1,2.3 c-0.2,1.7,1.2,3.2,2.7,4.1s3.2,1.5,4.4,2.7c2.2,2.1,2.2,6.1,0,8.2c-2.2,2.1-6.2,2-8.2-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,18.2c-1.5,6.7,0.5,13.8-0.3,20.7c2.4-0.1,4.9-0.1,7.4-0.2c0.2,0,0.3,0,0.4-0.1c0.1-0.1-0.1-0.3-0.2-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.2,27.6c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.2,27.6c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.2,27.6c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6,17.8c2.8-0.7,5.8-0.8,8.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.9,17.2c0.2,7.2,0.3,14.4,0.5,21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.8,40.2c-0.3-8.1-0.6-16.3-0.9-24.4c1.5,0.1,3,0.2,4.4,0.3c1.5,0.1,3,0.2,4.3,0.9c2.5,1.4,3.5,4.5,3.9,7.3 c0.4,2.9,0.4,5.9,0.1,8.9c-0.1,0.9-0.3,1.9-0.7,2.7c-0.8,1.6-2.6,2.6-4.4,3C70.6,39.5,68.5,39.5,65.8,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.1,19c-0.2-1.7-1.8-3-3.5-3.3c-1.7-0.3-3.5,0.2-5,1c-0.7,0.3-1.4,0.7-1.8,1.4c-0.4,0.6-0.5,1.2-0.6,1.9 c-1,5-1.1,10.2-0.4,15.2c0.1,1.1,0.4,2.2,1,3.2c1.3,1.8,3.9,2,6.1,2.1c1.3,0,2.7,0,3.6-0.9c0.5-0.5,0.8-1.2,1-1.9 c0.6-2.1,0.8-4.4,0.5-6.6c-1.5,0.4-3.2,0.5-4.7,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.1,42.1c1.1-8.9,1.4-18,0.8-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.4,13.9c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.6,8.3,21.2c-0.1-9.2-0.2-18.4-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.4,13.9c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.6,8.3,21.2c-0.1-9.2-0.2-18.4-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.1,80.8c-0.1,0.5-0.2,1-0.3,1.5c-0.6-9.1-0.6-18.3,1.4-26.5c2.5-2.2,6.8-1.7,9,0.8c2.2,2.5,2.1,6.6,0,9.2 c-2.1,2.6-6,3.4-9.1,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.5,69.3c1.3,4.2,2.6,8.3,3.9,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,58.5c3.7-1.3,7.7-1.9,11.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,58.9c-1.1,7-1.3,14.1-0.8,21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.3,58.5c3.7-1.3,7.7-1.9,11.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.7,58.9c-1.1,7-1.4,14.1-0.8,21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,55.7c0.3,8.2,0.2,16.4-0.3,24.6c0,0.3,0,0.7,0.3,0.8c0.3,0.1,0.4-0.5,0.1-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.1,55.7c0.3,8.2,0.2,16.4-0.3,24.6c0,0.3,0,0.7,0.3,0.8s0.4-0.5,0.1-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.5,56.3c-1.4-0.6-3,0-4.1,1c-1.1,1-1.7,2.4-2.2,3.8c-1.3,3.6-1.9,7.5-1.8,11.4c0.1,2.1,0.4,4.2,1.6,5.9 s3.5,2.7,5.4,1.9c1.9-0.8,2.7-2.9,3.2-4.9c0.8-2.9,1.4-5.8,1.8-8.8c0.3-2.1,0.4-4.4-0.3-6.4S243.5,56.7,242.5,56.3L242.5,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,81c0.4-8.4,1.3-16.8,2.9-25.1c2.1-0.4,4.2-0.5,6.3-0.4c0.8,8.5,1.6,17.1,2.4,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,69.5c1.6-1.2,3.7-1.6,5.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,56.7c-0.1,7.8,0.1,15.6,0.7,23.4c3.5-1.1,7.2-1.4,10.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,56.7c-0.1,7.8,0.1,15.6,0.7,23.4c3.5-1.1,7.2-1.4,10.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.8,58.9c-1.7-1-3.7-2.1-5.6-1.4c-1.5,0.5-2.4,1.9-3.2,3.3c-0.4,0.7-0.9,1.5-1,2.3 c-0.2,1.7,1.2,3.2,2.7,4.1s3.2,1.5,4.4,2.7c2.2,2.1,2.2,6.1,0,8.2c-2.2,2.1-6.2,2-8.2-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258,82.5c1.1-8.9,1.4-18,0.8-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,54.3c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.7,8.3,21.2c-0.1-9.2-0.2-18.5-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,54.3c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.7,8.3,21.2c-0.1-9.2-0.2-18.5-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,56.5c0.4,5.3,0.8,10.5,1.2,15.8c0.1,1.6,0.2,3.2,0.4,4.8c0.1,0.7,0.1,1.4,0.5,2c0.8,1.3,2.7,1.4,4.2,1.3 c1.1-0.1,2.4-0.2,3.2-0.9c0.8-0.8,1-2,1.2-3.1c0.8-6.7,1-13.5,0.7-20.2"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1 animate-svg-no-children",
    d: "M5.6,7.1C98.5,3,191.6,2.8,285.4,6.4c-0.3,29.2-0.6,58.4-0.9,88.1c-93.2-0.8-186.4-1.6-277.9-2.3 c-3.1-20-0.5-60.5-0.5-60.5S5.6,16.9,5.6,7.1z",
    style: {
      animationDelay: "4s",
      animationDuration: "1s"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignAndIllustrationV2);
export default __webpack_public_path__ + "static/media/design-and-illustration-v2.d4221b4501fb08688816d6080e3597d9.svg";
export { ForwardRef as ReactComponent };